<template>
  <fieldset class="tab tab-09 none-bg">
    <div class="heading-form a-center">
      <span class="number">9/18</span>
      <p class="c-yellow">ความเสี่ยงจากโรคร้ายแรง</p>
      <h2 class="heading-h2 c-white">
        คุณสูบบุหรี่ หรือใช้ชีวิตประจำวันร่วมกับ<span class="br767"
          >ผู้ที่สูบบุหรี่หรือไม่</span
        >
      </h2>
    </div>
    <div class="icw-fieldset-inner">
      <ul class="icw-fields">
        <li class="icw-field icw-field-full">
          <div class="icw-input icw-input-checkbox" id="rdoSmoking">
            <div class="checkbox checkbox-default">
              <input
                type="radio"
                name="radio9"
                id="smoke"
                class="css-checkbox"
                value="1"
                v-model="cigarette"
              />
              <label for="smoke" class="css-label">ใช่</label>
            </div>
            <div class="checkbox checkbox-default">
              <input
                type="radio"
                name="radio9"
                id="Nosmoke"
                class="css-checkbox"
                value="-1"
                v-model="cigarette"
              />
              <label for="Nosmoke" class="css-label">ไม่ใช่</label>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="icw-fieldset-action previous">
      <button
        type="button"
        class="btn btn-previous previous"
        @click="prevStep('tab-09', 'tab-08')"
      >
        ย้อนกลับ
      </button>
    </div>
    <button
      id="btnNextStepQ10"
      type="button"
      class="btn btn-next next"
      :class="{ 'btn-disabled': !isPass }"
      @click="beforeNextStep()"
    >
      ถัดไป
    </button>
  </fieldset>
</template>

<script>
import Vue from "vue";

import { my_storage } from "@/helpers/global_helper.js";
import { nextStep, prevStep } from "@/helpers/step_helper.js";

export default {
  name: "QuestionStep3_Q9",
  props: {
    QuestionType: String
  },
  data() {
    return {
      cigarette: my_storage(this.QuestionType, "cigarette")
    };
  },
  methods: {
    my_storage,
    nextStep,
    prevStep,
    beforeNextStep() {
      if (this.cigarette != "") {
        sessionStorage.setItem(this.QuestionType, JSON.stringify(this._data));
        this.nextStep("tab-09", "tab-10");
      }
    }
  },
  computed: {
    isPass() {
      return this.cigarette != "";
    }
  }
};
</script>
